// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ds6W","vLegacy":"SelectSecondary_vLegacy__3rJn6","error":"SelectSecondary_error__2pG4C","disabled":"SelectSecondary_disabled__3jbTD"};